import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dashboard-switcher',
  templateUrl: './dashboard-switcher.component.html',
  styleUrls: ['./dashboard-switcher.component.scss']
})
export class DashboardSwitcherComponent implements OnInit {
  @Output() CurrentVariant: EventEmitter<string> = new EventEmitter<string>();

  public variants: string[] = ['default', 'anonymous', 'nonmember', 'cpp', 'student'];
  public currentVariant: string;

  constructor() {
    this.CurrentVariant = new EventEmitter();
    this.currentVariant = this.variants[0];
    this.CurrentVariant.emit(this.currentVariant);
  }

  ngOnInit() {
  }

  SelectVariant(variantIndex: number) {
    this.currentVariant = this.variants[variantIndex];
    this.CurrentVariant.emit(this.currentVariant);
  }

}
